module.exports = __webpack_public_path__ + "static/3_digital_ads-e359e90a74ee2569a506903cb3a7e11f.webp";